module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/18Av3wi/tc-custom/FC-9781398403468.jpg?1692135073388?1731166563094",
      "alt": "This image is the cover for the book Enter Donegal"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Enter Donegal\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Enter Donegal is a highly entertaining story of a mischievous Irish Setter who becomes part of the Ellis family, and who, after several years of being the family pet, reveals that he can not only walk upright, but that he can read, write, and is a master of most sports. The story traces the powerful relationship he forms with each family member, and his adventures in helping Tom’s children, capturing burglars, confronting bullies, freeing other dogs from the council pound, and performing a rescue from a near-death experience. His hilarious ‘coming-out’ or making his talents known beyond the family, proves a sensation, but poses new challenges for the family. After a few remarkable years, Donegal makes another startling revelation to Tom with even greater challenges. The story shows the bond between people and dogs, the value of all living creatures, the short-lived and changing nature of fame, the idea that every life leaves an imprint, and the triumph of goodness.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Laurie Brady\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Laurie Brady is a published poet, a writer of short stories, a novelist, and a great dog lover who lives in Sydney, Australia. He has a keen sense of humour, particularly a liking for the ridiculous, and a love of literature and sport.  He has spent most of his working life as a teacher and a teacher educator, promoting engaging and quality schooling. He retired recently as professor of education at the University of Technology, Sydney.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0